import { useEffect, useState } from 'react';

// The value as it stood `delay` ms after its last change: a search box that asks
// the server waits for the typing to settle rather than asking per keystroke.
export function useDebouncedValue<T>(value: T, delay: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = window.setTimeout(() => setDebounced(value), delay);
    return () => window.clearTimeout(id);
  }, [value, delay]);
  return debounced;
}
